export default __webpack_public_path__ + "static/media/audio-gallery-primary.4c8166ce.svg";